import { Button } from 'braid-design-system';
import React from 'react';

import ExternalLink from 'src/components/ExternalLink/ExternalLink';

const FindOutMore = () => (
  <ExternalLink destination="/business-resources/franchise-advertising">
    <Button>Find out more</Button>
  </ExternalLink>
);

export default FindOutMore;
